import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon, TrendingUpIcon } from 'lucide-react';
const names = ['Lucas', 'Matías', 'Nicolás', 'Franco', 'Diego', 'Sebastián', 'Martín', 'Ezequiel', 'Facundo', 'Agustín', 'Joaquín', 'Tomás', 'Santiago', 'Ignacio', 'Manuel'];
// CIUDADES de Argentina (no provincias)
const cities = ['Buenos Aires', 'Córdoba Capital', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta Capital', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén Capital', 'Santiago del Estero', 'Corrientes Capital', 'Posadas', 'Bahía Blanca', 'Paraná', 'Formosa Capital', 'San Luis Capital', 'Catamarca Capital', 'La Rioja Capital', 'Río Cuarto', 'Comodoro Rivadavia', 'San Salvador de Jujuy', 'Concordia', 'San Nicolás', 'Tandil', 'Zárate', 'Quilmes', 'Lanús', 'Avellaneda', 'San Isidro'];
const messages = ['acaba de adquirir Método Barber Pro', 'acaba de comprar Método Barber Pro', 'acaba de unirse a la formación', 'acaba de invertir en su futuro profesional'];
const messagesWithColorimetria = ['acaba de comprar el pack completo: Método Barber Pro + Colorimetría', 'acaba de adquirir Método Barber Pro + Colorimetría', 'acaba de invertir en la formación completa con Colorimetría'];
function getRandomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [hasColorimetria, setHasColorimetria] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const name = getRandomItem(names);
      const city = getRandomItem(cities);
      const includesColorimetria = Math.random() > 0.65;
      setHasColorimetria(includesColorimetria);
      const messageTemplate = includesColorimetria ? getRandomItem(messagesWithColorimetria) : getRandomItem(messages);
      const newMessage = `${name} de ${city} ${messageTemplate}`;
      setMessage(newMessage);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(showPopup, 20000);
    const initialDelay = setTimeout(showPopup, 8000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialDelay);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 bg-gradient-to-br from-white to-gray-50 rounded-lg shadow-2xl border-2 border-[#c41e3a] p-3 max-w-xs z-50 animate-fade-in" role="status" aria-live="polite" data-id="element-220">
      <div className="flex items-start gap-2" data-id="element-221">
        <div className="bg-[#c41e3a] rounded-full p-1.5 flex-shrink-0" data-id="element-222">
          {hasColorimetria ? <TrendingUpIcon className="w-4 h-4 text-white" aria-hidden="true" data-id="element-223" /> : <CheckCircleIcon className="w-4 h-4 text-white" aria-hidden="true" data-id="element-224" />}
        </div>
        <div className="flex-1 min-w-0" data-id="element-225">
          <p className="text-gray-900 font-bold text-sm leading-snug" data-id="element-226">
            {message}
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-[#c41e3a] transition-colors flex-shrink-0" aria-label="Cerrar notificación" data-id="element-227">
          <XIcon className="w-4 h-4" aria-hidden="true" data-id="element-228" />
        </button>
      </div>
    </div>;
}